module.exports = __webpack_public_path__ + "img/warply.6aa87bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/warply.png
// module id = dORd
// module chunks = 39 44